import { ITEMS } from './items';

/** What the travelling merchant in the plaza sells, and for how much (ตำลึง). */
export interface ShopEntry {
  readonly item: string;
  readonly price: number;
}

export const SHOP: readonly ShopEntry[] = [
  { item: 'iron-sword', price: 60 },
  { item: 'navy-coat', price: 50 },
  { item: 'red-band', price: 40 },
  { item: 'azure-sword', price: 320 },
  { item: 'bamboo-hat', price: 260 },
  { item: 'black-vest', price: 300 },
  { item: 'wolf-pelt', price: 240 },
];

/** Items sell back for this fraction of their worth. */
export const SELL_RATE = 0.4;

/** What an item is worth when sold (rolled legends fetch a fixed sum). */
export function sellPrice(base: string, rolled: boolean): number {
  if (rolled) return 800;
  const e = SHOP.find((x) => x.item === base);
  const worth = e
    ? e.price
    : base === 'crimson-sword' || base === 'crimson-coat'
      ? 600
      : base === 'jade-crown'
        ? 500
        : (ITEMS[base]?.worth ?? 100);
  return Math.max(1, Math.round(worth * SELL_RATE));
}

/**
 * What the black-market buyers (พ่อค้าตลาดมืด, data/offlineWork.ts `SACK_BUYERS`) sell, silver each: goods
 * (data/professions.ts), bought with `blackBuy` (systems/offlineWork.ts).
 */
export const BLACK_MARKET: readonly { readonly good: string; readonly price: number }[] = [
  { good: 'knockout-powder', price: 50 },
];
